/**
 * renderEntity — the recursive dispatch seam primitive.
 * "Give me an entity + thread context, and I'll render it."
 * Mounts note3's own TreeItem (which itself dispatches to plugins).
 */
import type { EntityID, Thread } from '@wovin/core'
import { render } from 'solid-js/web'
import { TreeItem } from '../../components/TreeItem'
import { ThreadContext } from '../../ui/reactive'

export function makeRenderEntity(rawThreadGetter: () => Thread) {
	return (el: HTMLElement, entityID: EntityID, _opts?: Record<string, unknown>): () => void => {
		return render(() => (
			<ThreadContext.Provider value={rawThreadGetter}>
				<TreeItem blockID={entityID} />
			</ThreadContext.Provider>
		), el)
	}
}
